<template>
  <component :is="getContent()" />
</template>

<script>
import RuleComponentVi from "@components/content/rule-vi.vue";
import RuleComponentEn from "@components/content/rule-en.vue";
import RuleComponentTh from "@components/content/rule-th.vue";

export default {
  components: {
    RuleComponentVi,
    RuleComponentEn,
    RuleComponentTh
  },
  methods: {
    getContent: function() {
      const lang = this.$route.query.lang;
      switch (lang) {
        case "en":
          return RuleComponentEn;
        case "th":
          return RuleComponentTh;
        default:
          return RuleComponentVi;
      }
    }
  }
}
</script>

<style></style>
